import { createTheme } from '@mui/material';

/**
 * High-contrast accessibility theme — flat black-on-white, no gradients,
 * textures, or shadows. Used in place of the Frostgrave/Stargrave themes
 * when the user enables "High Contrast Mode" from the warband drawer.
 */
export const highContrastTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0b3d91', contrastText: '#ffffff' },
    secondary: { main: '#6a1b9a', contrastText: '#ffffff' },
    background: { default: '#ffffff', paper: '#ffffff' },
    text: { primary: '#000000', secondary: '#000000' },
    divider: '#000000',
  },
  shape: { borderRadius: 4 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'html, body, #root': { height: '100%' },
        body: {
          backgroundColor: '#ffffff',
          backgroundImage: 'none',
          color: '#000000',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: 'none',
          border: '2px solid #000000',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: 'none',
          border: '2px solid #000000',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: 'none',
          border: '2px solid #000000',
          textShadow: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: 'none',
          textShadow: 'none',
          border: '2px solid #000000',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: 'none',
          backgroundColor: '#000000',
          color: '#ffffff',
          borderBottom: '2px solid #000000',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          backgroundColor: '#ffffff',
          border: '2px solid #000000',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          backgroundColor: '#ffffff',
          border: '2px solid #000000',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          backgroundColor: '#ffffff',
          border: '2px solid #000000',
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false,
      },
      styleOverrides: {
        root: {
          '&.Mui-focusVisible': {
            outline: '3px solid #0b3d91',
            outlineOffset: '2px',
          },
        },
      },
    },
  },
});
